<div class="navbar-content" ngcPerfectScrollbar>
    <!--<ngc-navigation></ngc-navigation>-->
    <div id="main-navigation" class="nav vertical">
        <ng-container *ngFor="let item of navigationModel">
            <div *hasRole="item.permission">
                <ngc-nav-group *ngIf="item.type=='group'" [item]="item"></ngc-nav-group>
                <ngc-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></ngc-nav-collapse>
                <ngc-nav-item *ngIf="item.type=='item'" [item]="item"></ngc-nav-item>
            </div>
        </ng-container>
    </div>
</div>
